export default "__VITE_ASSET__B8mOMRA7__"